<template>
  <div>
    <div class="headbt">
      <span class="zjt" @click="fh"><img src="../../assets/img/zjt.png" ></span>答题&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>

    <div class="rwbt">
      <div class="bwbt_1">
          {{plainwz.title}}
      </div>
      <div class="xxjs  ">
          <div class="xxjs_dt">
            <div  v-for="(item,index) in dt">
              <div class="xxjs_dt_title" v-if="index == current_show">
              {{index+1}}、{{item.subject}}
              </div>

              <div class="bt_bkx" :style="{width:bfb}" v-if="index == current_show"></div>
              <div class="sjxs" v-if="index == current_show">
                  <div class="col-sm-6 col-6 col-md-6 yd">已答：<span class="jiahong">{{ydt}}</span> / {{all_count}}</div>
                  <div class="col-sm-6 col-6 col-md-6 ys">用时: <span class="sj">{{timeStr}}</span></div>
              </div>
              <div class="bt_xz" v-if="index == current_show">
                <el-radio-group   v-model="formdata2[item.id]"  style="display: flex;
                        flex-flow: column nowrap;
                        align-items: flex-start;" @change="handleRadioChange(index,item.id)" >
                       <el-radio   v-for="(item1_14,index1_14) in item.options" :key="index1_14"
                        :label="item1_14.value">
                       {{item1_14.key}}

                       </el-radio>
                   </el-radio-group>
              </div>
               </div>
              <div v-for="(item1,index1) in dt">
                <div v-if="index1 == current_show">
              <div class="bt_xz_xt" v-show="last_ti == 0">
                  <div class="col-sm-4 col-4 col-md-4 ">
                      <div class="syit sxtn"  @click="syt(-1,index1)"   :class="{ first_ti: first_ti_active }">上一题</div>
                  </div>
                  <div class="col-sm-4 col-4 col-md-4 ">
                     <div class="xyit sxtn"  @click="syt(+1,index1)" :class="{ last_ti: last_ti_active }">下一题</div>
                  </div>
                    <div class="col-sm-4 col-4 col-md-4 " @click="tjrw" v-if="dtxx.length == all_count">
                       <div class="xyit sxtn">提交答案</div>
                    </div>
              </div>
              <div class="bt_xz_xt" v-show="last_ti == 1">
                  <div class="col-sm-4 col-4 col-md-4 ">
                      <div class="syit sxtn" @click="syt(-1,index1)" :class="{ first_ti: first_ti_active }">上一题</div>
                  </div>
                  <div class="col-sm-4 col-4 col-md-4 ">
                     <div class="xyit sxtn" @click="syt(+1,index1)" :class="{ last_ti: last_ti_active }">下一题</div>
                  </div>
                  <div class="col-sm-4 col-4 col-md-4 " @click="tjrw" v-if="dtxx.length == all_count">
                     <div class="xyit sxtn">提交答案</div>
                  </div>
              </div>

              </div>
              </div>
              <div class="zdxyt col-sm-12 col-12 col-md-12">
                  <el-checkbox v-model="checked" >

                          打完自动下一题

                  </el-checkbox>

                   <!-- <input type="checkbox" name="xt" >打完自动下一题 -->
              </div>


              <div class="ydtylwz">
                已答题预览:
              </div>
              <div class="ydtyl">


                   <div v-for="(itema,index) in dt">


                   <div class="timu current_timu" v-if="index+1 == current_ti">
                       {{index+1}}
                   </div>
                    <div class="timu yida" v-else-if="isInArray(itema.id, dtxx)">
                          {{index+1}}
                    </div>
                    <div class="timu weida" v-else>
                       {{index+1}}
                    </div>
                  </div>


              </div>
          </div>
      </div>


    </div>


    <div class="bkx">

    </div>

		<div class="footer " style="display: none;">
		  <div class="item_list_menu col-sm-3 col-3 col-md-3"  @click="tz('/base/index')">
			  <div class="dibumenu">
          	 <img src="../../assets/img/home.png" >
			</div>
			  <div class="xmtitle ">
			  	首页
			  </div>
		  </div>
			<div class="item_list_menu col-sm-3 col-3 col-md-3">
				<div class="dibumenu">
          	<!-- <img src="../../static/wd.png" > -->
             <img src="../../assets/img/cp_xz.png" >
				</div>
				<div class="xmtitle xmtitle_active">
					测评任务
				</div>
			</div>
			<div class="item_list_menu col-sm-3 col-3 col-md-3" @click="tz('/user/wdcp')">
				<div class="dibumenu">
				 	 <img src="../../assets/img/wdcp.png" >
				</div>
				<div class="xmtitle ">
					我的测评
				</div>
			</div>
			<div class="item_list_menu col-sm-3 col-3 col-md-3" @click="tz('/user/index')">
				<div class="dibumenu">
					 <img src="../../assets/img/wd.png" >
				</div>
				<div class="xmtitle ">
					我的
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import {getdati,getques,tjdt} from '../../api/baseset'
var intervalId;
  export default {
      data() {
        return {
          dx:'',
          dt:[],
          dxsj:[
            {key:'A、是',value:'a'},
            {key:'B、否',value:'b'},
          ],
          auto_next:true,
          bfb:'0%',
          checked:true,
          current_show:0,
          second:0,
          formdata2:{},
          current_ti:1,
          all_count:0,
          last_ti:0,
          first_ti_active:true,
          last_ti_active:false,
          timeStr:'',

          js:"",
          current_val:'',
          curs:1,
          taskId:'',
          lbid:'',
          plainwz:{
            title:''
          },
          rwtj:[

          ],
          rw:{

          },
          tak:{},
          ydt:0,
          dtxx:[],
          daxx:[],
          hc:{},
          bl:''
        }
      },
      mounted() {
        this.lbid = this.$route.params.id;



   if(localStorage.getItem('profileData')){
              const data = JSON.parse(localStorage.getItem('profileData'))

             this.plainwz.title = data.title
             this.tak.taskId = data.rwid
             this.tak.gaugeId = data.rwid
            this.rw.taskId = data.rwid
            this.rw.gaugeId = data.lbid
            this.bl = this.rw.taskId +"_"+this.rw.gaugeId

            if(localStorage.getItem(this.bl) ){
              const bll = JSON.parse(localStorage.getItem(this.bl))

              //this.wrtiecache(0)
              this.readcache(bll)
            }
            this.jsjq();
             this.getdata(this.rw.gaugeId,this.rw.taskId);
            // this.jsjq();
           // this.rw.gagueId = data.lbid
   }else{
     console.log('缓存jsjq')
 this.jsjq();
   }
     // this.jsjq();
      },
      methods: {
        readcache(data){

           this.current_show = data.current_show
           this.current_ti = data.current_ti
           this.bfb = data.bfb
           this.dtxx = data.dtxx
           this.last_ti_active = data.last_ti_active
           this.rwtj = data.rwtj
           this.ydt = data.ydt
           this.first_ti_active = data.first_ti_active
           this.second = data.second
           this.formdata2 = data.formdata2
           //this.jsjq();
        },
        wrtiecache(state){ //1 写入缓存 0 清空缓存
            if(state == 0){
                 localStorage.removeItem(this.bl);
            }else{
              this.hc.current_show = this.current_show
              this.hc.current_ti = this.current_ti
              this.hc.bfb = this.bfb
              this.hc.dtxx = this.dtxx
              this.hc.last_ti_active = this.last_ti_active
              this.hc.rwtj = this.rwtj
              this.hc.ydt = this.ydt
              this.hc.first_ti_active = this.first_ti_active
              this.hc.second = this.second
              this.hc.formdata2 = this.formdata2
              localStorage.setItem(this.bl, JSON.stringify(this.hc))

            }

        },
        getdata(id,rwid){

          this.loading = true
           let parm = {gaugeId:id,taskId: rwid}

            getques(parm)
             .then(res => {

               this.loading = false
               if (res.code != 200) {
                 this.$message({
                   type: 'info',
                   message: res.msg
                 })
               } else {

                  if(res.data[0].isAnswer == false){
                      this.dt = res.data
                      this.all_count = res.data.length
                  }else{
                   /* this.$message({
                      type: 'info',
                      message: '当前测试题已经答过了'
                    }) */
                    this.$alert('当前测试题已经答过了，请选择其他测试题', '温馨提示', {
                              confirmButtonText: '确定',
                              callback: action => {
                                this.$router.push("/user/cprw/");
                              }
                            });
                    /* const intervalIdaa = setInterval(() => {
                      clearInterval(intervalIdaa);
                      this.$alert.close();
                     //this.$router.replace("/user/cprw/");
                     this.$router.push("/user/cprw/");
                      // this.second = seconds;
                    }, 5000); */

                  }
                 // this.formdata2 = res.data.vmodel



               }
             })
             .catch(err => {
               this.loading = false
               this.$message.error('数据加载失败，请稍后再试！')
             })

        },

        // 搜索事件
        search() {
          this.formInline.page = 1
          this.formInline.limit = 10
          this.getdata(this.formInline)
        },
         isInArray(item, arr) {
              return arr.includes(item);
         },
        // 重置搜索
        formReset() {
          this.formInline.key = '';
        },
        shouli() {

        },
        syt(num,sx){

            this.last_ti_active = false
             this.first_ti_active = false

           if(num == 1){

              if (Object.keys(this.formdata2)[sx] === undefined) {
                // do something
                 // this.$message.error('请先完成当前题目！')
                 // return ;
               }
                this.ydt = Object.keys(this.formdata2).length
                if(this.ydt == this.all_count){
                    this.last_ti = 1;
                    this.bfb = "100%";

                }
              //  sx = sx+1;

                if(sx+1 == this.all_count){ //最后一个
                    this.last_ti_active = true
                }else if(sx == 0){ //第一个
                    this.current_ti  =sx+2;
                    this.current_show = sx+1;
                }else{
                     this.current_ti  =sx+2;
                     this.current_show = sx+1;

                }

                this.bfb = (this.ydt/this.all_count)*100+"%";

                return ;



           }else{

              if(sx <=1){
                  this.first_ti_active = true
                }
               this.current_ti = this.current_ti+num;
               this.current_show = this.current_show+num;
               if(this.current_show < 0){
                 this.current_show= 0;
               }
               if(this.current_ti < 0){
                 this.current_ti= 0;
               }
                this.wrtiecache(1);
              return ;



           }

        },

        handleRadioChange(sx,tid){

            this.zjrwtj(sx,tid);

             if (!this.dtxx.includes(tid)) {
               this.dtxx.push(tid)
             }

          if(this.checked == true){
            this.current_ti = sx+1
            this.current_ti = this.current_ti+1
            if(sx ==0){

            }else{

            }

              if(sx+1 == this.all_count){ //最后一个

                  this.ydt = this.ydt
                  this.last_ti = 1;
                  this.last_ti_active = true
                  this.bfb = "100%";
                  this.first_ti_active = false
                  this.current_ti = this.all_count
              }else{

                this.current_show = sx+1; //不是最后一个的时候 向下移动

                this.last_ti_active = false


              }
              if(sx == 0){
                   this.first_ti_active = false
              }
                this.ydt = Object.keys(this.formdata2).length
                this.bfb = (this.ydt/this.all_count)*100+"%";
              this.wrtiecache(1);

          }

          return ;



            if(this.checked == true){
              this.first_ti_active = false
              if(this.ydt == this.all_count){

                  this.ydt = this.ydt
                    this.last_ti = 1;
                     this.last_ti_active = true
                     this.bfb = "100%";
                     this.current_ti = this.all_count+1
              }else if(this.ydt > sx+1){


               }else{

                  if(this.all_count == this.current_show){
                      this.last_ti = 1;
                       this.last_ti_active = true
                       this.bfb = "100%";
                       this.current_ti = this.all_count+1

                  }else{
                    this.current_ti = this.current_ti+1
                    this.current_show = this.current_show+1;
                    this.last_ti_active = false

                  }

                   this.ydt = Object.keys(this.formdata2).length
                  if(this.ydt <0){
                    this.ydt = 0;
                  }
                  if(this.ydt >= this.all_count){
                    this.ydt = this.all_count+1;
                  }
              }

              this.curs = this.current_ti
               this.bfb = (this.ydt/this.all_count)*100+"%";
            }



        },
        chuli() {
          this.dialogVisible = true;
        },
        tz(url){

          this.$router.push(url);
        },
        fh(){
          clearInterval(intervalId);
         window.history.go(-1);
        },
        radioxz(){

        },
        jsq(){

        },
        zjrwtj(sx,tid){

             let rsda = {};

             let xxx = this.dt[sx].options;
             let xx_title = '';

             for(var j =0; j< xxx.length;j++){
                 if(this.formdata2[tid] ==xxx[j].value ){
                   xx_title = xxx[j].key
                 }

             }

              rsda.option = xx_title;
              rsda.optionValue = this.formdata2[tid];
              rsda.detailedId = tid;
              rsda.taskId = this.rw.taskId;
              rsda.gaugeId = this.rw.gaugeId;

             this.rwtj[sx] = rsda;

             return ;
        },
        tjrw(){


          this.loading = true
           let parm = this.rwtj

            tjdt(parm)
             .then(res => {
               this.loading = false
               if (res.code != 200) {
                 this.$message({
                   type: 'info',
                   message: res.msg
                 })
               } else {

                  this.$message({
                    type: 'success',
                    message: res.msg
                  })
                  this.wrtiecache(0)
                  this.$router.replace("/user/wdcpdetail/"+this.lbid+'/'+this.rw.taskId+'/'+this.plainwz.title);
                   //this.$router.push("/user/wdcpdetail/"+this.lbid+'/'+this.rw.taskId);
                   //跳转
               }
             })
             .catch(err => {
               this.loading = false
               this.$message.error('数据加载失败，请稍后再试！')
             })
        },
        jsjq(){

        // let seconds = this.second;

         // 创建计时器，每1000毫秒（1秒）执行一次

          intervalId = setInterval(() => {
          var sj =  this.secondsToHms(this.second)

          this.timeStr = sj;
           this.second++;
           //this.hc.second = this.second
          // this.wrtiecache(1);
           // this.second = seconds;
         }, 1000);
        },
         secondsToHms(d) {
            d = Number(d);
            var h = Math.floor(d / 3600);
            var m = Math.floor(d % 3600 / 60);
            var s = Math.floor(d % 3600 % 60);
            if(s <10){
              s = "0"+s;
            }
            if(m ==0){
              m="00"+":";
            }else if(m <10){
              m = "0"+m+":";
            }
            if(h >0){
              h = h+":";
            }else{
              h='';
            }
            return h+m+s;

        }



      }
    }
  </script>

<style scoped>
  	body{
  			background-color: #EFEFF4;
  		}
      /* 修改复选框的大小 */
      .el-checkbox__inner {
        width: 20px; /* 设置复选框的宽度 */
        height: 20px; /* 设置复选框的高度 */
      }


  		.footer {
  		  position: fixed ;
  		  bottom: 0;
  		  width: 100%;
  		  height: 60px; /* 底部栏的高度 */

  		  background-color: white;
  		  display: flex;
  		  border-top: solid 1px #E6EAEC;
       /* border: solid 1px red; */
        margin-left:  0 !important;
  		}
  		.item_list_menu{
  			/* border: solid 1px red; */
  			text-align: center;
  		}
  		.dibumenu{
  			width: 100%;
  			text-align: center;
  			padding-top: 3px;
  		}
  		.dibumenu img{
  			width: 24px;
  			height: 24px;
  		}
  		.xmtitle{
  			text-align: center;
  			font-size: 12px;
  			color: #666666;
  		}
  		.xmtitle_active{
  			color: #00DDA3;
  		}




    .dibuxian{
    	width: 100%;
    	height: 90px;
    }
    .yjt img{
    	width: 24px;
    	height: 24px;
    }



    .bkx{
      width: 100%;
      height: 80px;
    }


    .xingxing{
    	color:red;
    }
    .rwbt{
      width: 100%;
      height: auto;

      background-color: white;
      margin-top: 15px;
       box-shadow: 2px 2px 2px 2px #ccc,-2px -2px 2px 2px #ccc;
    }
    .rwbtaaa{
       box-shadow: 0 0 0 0 ;
    }
    .bwbt_1{
      width: 92%;
      height: 3rem;
      margin: 0 auto;
      line-height: 3rem;
      /* border: solid 1px #ccc; */
     /* padding-top: -10px; */
      font-size:14px;
      color: black;
      font-weight: bold;

    }
    .bwbt_1::before {
        content: "   ";
        display:inline-block;
        position: relative;
        width: 5px;
          /* background-color: red; */
        border-left:solid 5px #00DDA3;
        height: 25px;
        padding-left: 7px;
        top:5px;
      }
      .bwbt_11{
        width: 92%;
        height: 3rem;
        margin: 0 auto;
        line-height: 3rem;

        font-size:14px;
        color: black;
        font-weight: bold;

      }
      .bwbt_11::before{
        content: "   ";
        display:inline-block;
        position: relative;
        width: 5px;
          /* background-color: red; */
        border-left:solid 5px #FF6712;
        height: 25px;
        padding-left: 7px;
        top:5px;
      }
      .xxjs{
        width: 100%;
        height: auto;
        padding-top: 5px;
        padding-bottom: 10px;
       /* border: solid 1px red; */
        font-size: 14px;
      }
      .xxjs_dt{
        width: 90%;
        height:  auto;
        margin: 0 auto;
        border-radius: 10px 10px 10px 10px;
        border: solid 1px #E6EAEC;
        overflow:auto;
        padding-bottom:15px;
      }
      .bt_bkx{
        height: 3px;
        background-color: #00DDA3;
      }
      .xxjs_dt_title{
        /* height: 35px; */
        height: auto;
        line-height: 38px;
        padding-left: 10px;
      }
      .bt_xz{
        width: 80%;
        height: auto;
        margin: 0 auto;
        margin-top: 10px;
      }

        .el-radio{
          margin-top: 20px;
        }
      /* 选中后的字体颜色 */
      .el-radio__input.is-checked + .el-radio__label {
        color: #28d4c1 !important;
      }
      /* 选中后小圆点的颜色 */
      .el-radio__input.is-checked .el-radio__inner {
        background: #28d4c1 !important;
        border-color: #28d4c1 !important;
      }
      .sjxs{
        width: 100%;
        height: 25;
        /* border: solid 1px red; */
        display: flex;
        line-height: 25px;
        margin-top: 5px;
        border-bottom: solid 1px #E6EAEC;
      }
      .yd{
        padding-left: 11px;
        font-size: 13px;
        color: #666666;
      }
      .ys{
        font-size: 13px;
        color: #666666;
        padding-right: 11px;
        text-align:right;
      }
      .jiahong{
        color: red;
      }
      .sj{
        color: rgb(21, 183, 185);
      }
      .bt_xz_xt{
        display: flex;
        width: 100%;
        height: 30px;
        /* border: solid 1px red; */
        margin-top: 35px;
      }
      .sxtn{
        width: 80%;
        height: 26px;
        margin: 0 auto;
        text-align: center;
        line-height: 26px;
        border-radius: 7px 7px 7px 7px;
        color: white;

      }
      .syit{
        background-color: #00DDA3;
      }
      .xyit{
        background-color: #00DDA3;
      }
      .zdxyt{
        font-size: 10px !important;
        padding-left: 10%;
        color: #ccc;
        margin-top: 25px;
        font-size: 10px !important;
      }
      .zdxyt .el-checkbox__label {
        font-size: 10px !important;
      }

      .zdxyt .el-checkbox .el-checkbox__label{
        font-size: 10px !important;
      }
      .el-checkbox__label{
        font-size: 5px !important;
      }
      .el-checkbox__input.is-checked+.el-checkbox__label {
          color: #00DDA3 !important;
      }
      .ydtyl{
        width: 95%;
        height: auto;
        margin: 0 auto;
        padding-top: 10px;
        /* padding-top: 10px; */
        padding-bottom: 30px;
        /* border: solid 1px red; */
      }
      .timu{
        width: 22px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        color: white;
        border-radius: 2px 2px 2px 2px;
        background-color: #00DDA3;
        float:left;
        margin-left: 5px;
        margin-top:5px;
      }
      .current_timu{
        background-color:#FFAA30 ;
      }
      .weida{
        background-color:#999999 ;
      }
      .ydtylwz{
          width:90%;
          height:26px;
          line-height: 26px;
          margin:0 auto;
          color: #666666;
          margin-top: 10px;
          font-weight: bold;
      }
      .first_ti{
        background-color: #808080;
      }
      .last_ti{
        background-color: #808080;
      }
      .jbm{
        width: 100%;
        height: 30px;
      /*  border: solid 1px red; */
      }
</style>



// WEBPACK FOOTER //
// src/views/user/dati.vue